import { createPaginatedInfiniteQuery, type QueryApi } from "../../api/query";

export function createUseAmazonStatisticsDaily($api: QueryApi) {
  const usePaginatedInfiniteQuery = createPaginatedInfiniteQuery($api);

  return function useAmazonStatisticsDaily(options?: { enabled?: boolean }) {
    return usePaginatedInfiniteQuery(
      "/amazon-statistics/daily",
      { sort: ["day,desc"], size: 30 },
      options,
    );
  };
}
